module.exports = __webpack_public_path__ + "assets/img/bg.c7070d00.png";